import { type FocusEvent, useState } from 'react';
import { ChevronDown, Xmark } from '../../../assets/Icons';
import type {
  IDropdownButton,
  IDropdownButtonInternalProps
} from '../../../types/Dropdown/dropdown_button/dropdownBtn';
import styles from './dropdown-button.module.scss';

export const DropdownButton = ({
  type = 'button',
  direction,
  color = 'secondary',
  leadingIcon,
  trailingIcon,
  hideDropdownChevron = false,
  placeholder,
  label,
  text,
  disabled = false,
  onClickHandler,
  onBlurHandler,
  onClearHandler,
  renderAs,
  ...internalProps
}: IDropdownButton) => {

  const { toggleDropdown, closeDropdown } = (internalProps as IDropdownButtonInternalProps);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleClick = (e: any) => {
    onClickHandler?.(e);
    toggleDropdown?.();
    setIsMenuOpen(prev => !prev);
  };

  const handleBlur = (e: FocusEvent<HTMLButtonElement>) => {
    onBlurHandler?.(e);
    setIsMenuOpen(false);
  };

  const handleClear = (e: any) => {
    e.stopPropagation();
    closeDropdown?.();
    onClearHandler?.(e);
    setIsMenuOpen(false);
  };

  return (
    renderAs ?
      <div
        className={styles['dropdown-btn__render-as']}
        data-dropdown-btn-disabled={disabled}
        data-dropdown-custom-btn
        onClick={handleClick}
      >
        {renderAs}
      </div>
      :
      <button
        className={styles['dropdown-btn']}
        type="button"
        disabled={disabled}
        onClick={handleClick}
        onBlur={handleBlur}
        data-dropdown-btn-type={type}
        data-dropdown-btn-color={color}
        data-dropdown-btn-menu-open={isMenuOpen}
        {...(label ? { "data-dropdown-btn-label": label } : {})}
      >
        {leadingIcon && <div className={styles['dropdown-btn__leading-icon']}>{leadingIcon}</div>}

        {
          label &&
          <div className={styles['dropdown-btn__label']}>{label}</div>
        }

        {
          (text || placeholder) &&
          <div
            style={direction ? { direction } : {}}
            className={`${styles['dropdown-btn__text']} ${!text ? styles['dropdown-btn__text--placeholder'] : ''}`}
          >
            {text || placeholder}
          </div>
        }

        {trailingIcon && <div className={styles['dropdown-btn__trailing-icon']}>{trailingIcon}</div>}

        {!hideDropdownChevron && <div className={styles['dropdown-btn__dropdown-chevron']}>{ChevronDown}</div>}

        {onClearHandler && <div className={styles['dropdown-btn__clear']} onClick={handleClear}>{Xmark}</div>}
      </button>
  )
};